export default __webpack_public_path__ + "static/innvotive-67bc0f0cfda8f0044025ca16407d8aed.png";